import { render, staticRenderFns } from "./moregister.vue?vue&type=template&id=4e15741e&scoped=true"
import script from "./moregister.vue?vue&type=script&lang=js"
export * from "./moregister.vue?vue&type=script&lang=js"
import style0 from "./moregister.vue?vue&type=style&index=0&id=4e15741e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e15741e",
  null
  
)

export default component.exports